import Enum from "../../../../../enums/Enum";

const EnumGiftStatus = new Enum({
    SENT: {name: "Sent"},
    CANCELLED: {name: "Cancelled", colorClass: "disc-danger"},
    REDEEMED: {name: "Redeemed", colorClass: "disc-green"},
    EXPIRED: {name: "Expired", colorClass: "disc-grey"}
});

export default EnumGiftStatus;